import { Typography } from '@material-ui/core';
import React from 'react';
import { getService } from '../../../firebase';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { openModal } from '../../../store/reducers/modalConductor';
import SimpleActionAlert from '../../SimpleAlert/SimpleActionAlert';

const sendPaymentReminderEmailService = getService('messaging', 'sendpaymentreminderemail');

export interface Props {
  transactionId: string;
}

const SendPaymentReminderModal: React.FC<Props> = (props: Props) => {
  const { transactionId } = props;

  const dispatch = useAppDispatch();

  const { me, shop } = useAppSelector(state => ({
    me: state.users.me,
    shop: state.shops.shop,
  }));

  const handleSendEmail = async () => {
    try {
      await sendPaymentReminderEmailService({ transactionId });
      dispatch(
        openModal({
          modalType: 'SIMPLE_ALERT_V2',
          modalProps: {
            show: true,
            title: 'Success',
            content: 'Payment reminder email successfully sent.',
            buttonText: 'Done',
          },
        }),
      );
    } catch (err) {
      dispatch(
        openModal({
          modalType: 'SIMPLE_ALERT_V2',
          modalProps: {
            show: true,
            content: 'Error sending email.',
            buttonText: 'Close',
          },
        }),
      );
    }
  };

  return (
    <SimpleActionAlert
      show
      title="Send Payment Reminder Now?"
      content={
        <Typography variant="body1" style={{ textAlign: 'center' }}>
          This will send a payment reminder email to your customer.
        </Typography>
      }
      buttonText="Send Now"
      actionText="Sending"
      color="default"
      handleAction={handleSendEmail}
    />
  );
};

export default SendPaymentReminderModal;
